import { isInternalMailTest } from "./mailAttribution.js";

const SIGNUP_ATTRIBUTION_KEY = "signupAttribution";

const attributionFields = [
  ["category", ["category", "llTopic", "ll_topic", "n_keyword"]],
  ["llTopic", ["llTopic", "ll_topic", "category", "n_keyword"]],
  ["llKeyword", ["llKeyword", "ll_keyword", "n_keyword"]],
  ["llMatch", ["llMatch", "ll_match", "n_match"]],
  ["utmSource", ["utmSource", "utm_source", "n_media"]],
  ["utmMedium", ["utmMedium", "utm_medium"]],
  ["utmCampaign", ["utmCampaign", "utm_campaign"]],
  ["utmTerm", ["utmTerm", "utm_term", "n_query"]],
  ["utmContent", ["utmContent", "utm_content"]],
];

const attributionParamNames = [
  "category",
  "llTopic",
  "llKeyword",
  "llMatch",
  "utmSource",
  "utmMedium",
  "utmCampaign",
  "utmTerm",
  "utmContent",
  "referrer",
  "landingPath",
];

const getFirstParam = (params, queryKeys) => {
  for (const key of queryKeys) {
    const value = params.get(key);
    if (value) return value;
  }

  return "";
};

export const captureSignupAttribution = () => {
  if (typeof window === "undefined") return;

  try {
    if (isInternalMailTest()) return;
    if (localStorage.getItem(SIGNUP_ATTRIBUTION_KEY)) return;

    const params = new URLSearchParams(window.location.search);
    const hasAttributionParam = attributionFields.some(([, queryKeys]) =>
      queryKeys.some((key) => params.has(key))
    );

    if (!hasAttributionParam) return;

    const attribution = attributionFields.reduce((acc, [field, queryKeys]) => {
      acc[field] = getFirstParam(params, queryKeys);
      return acc;
    }, {});

    attribution.referrer = document.referrer || "";
    attribution.landingPath = window.location.pathname || "";

    localStorage.setItem(SIGNUP_ATTRIBUTION_KEY, JSON.stringify(attribution));
  } catch (error) {
    console.error("유입 정보 저장 실패:", error);
  }
};

export const getSignupAttribution = () => {
  if (typeof window === "undefined") return null;

  try {
    if (isInternalMailTest()) return null;
    const value = localStorage.getItem(SIGNUP_ATTRIBUTION_KEY);
    if (!value) return null;

    return JSON.parse(value);
  } catch (error) {
    console.error("유입 정보 조회 실패:", error);
    return null;
  }
};

export const getSignupAttributionCategory = () => {
  const attribution = getSignupAttribution();
  return attribution?.category || "";
};

export const clearSignupAttribution = () => {
  if (typeof window === "undefined") return;

  try {
    localStorage.removeItem(SIGNUP_ATTRIBUTION_KEY);
  } catch (error) {
    console.error("유입 정보 삭제 실패:", error);
  }
};

export const appendSignupAttributionParams = (params) => {
  const attribution = getSignupAttribution();
  if (!attribution) return params;

  attributionParamNames.forEach((name) => {
    const value = attribution[name];
    if (value) {
      params.set(name, value);
    }
  });

  return params;
};
